//  import React, { useState } from "react";
// import { motion } from "framer-motion";

// const BusinessPromo = () => {
//   const [showPopup, setShowPopup] = useState(false);

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };

//   return (
//     <>
//       <style>{`
//         .containerss {
//           display: flex;
//           flex-direction: row;
//           align-items: center;
//           justify-content: space-between;
//           padding: 50px;
//           font-family: Arial, sans-serif;
//           height: auto;
//           background-color:white;
//           overflow: hidden;
//           flex-wrap: wrap;
//         }

//         .text-sectiony {
//           max-width: 50%;
//           text-align: left;
//         }

//         .image-sectiony {
//           display: flex;
//           justify-content: flex-start;
//           width: 50%;
//         }

//         .imagess {
//           width: 100%;
//           max-width: 681px;
//           border-radius: 10px;
//         }

//         .headingyss {
//           font-size: 36px;
//           font-weight: bold;
//           color: #0e7f9d;
//           text-align:left;
//         }

//         .bold {
//           color: #ffe124;
//         }

//         .paragraph {
//           font-size: 17px;
//           color: black;
//           margin: 10px 0 20px;
//           text-align:left;
//           font-family: 'Poppins', sans-serif;
//         }

//         @media (max-width: 768px) {
//           .containerss {
//             flex-direction: column-reverse;
//             height: auto;
//           }

//           .text-sectiony,
//           .image-sectiony {
//             max-width: 100%;
//             width: 100%;
//             text-align: center;
//             justify-content: center;
//           }

//           .headingyss {
//             font-size: 36px;
//           }

//           .imagess {
//             max-width: 90%;
//             margin: 0 auto;
//           }
//         }

//         @media (max-width: 480px) {
//           .headingyss {
//             font-size: 30px;
//           }

//           .paragraph {
//             font-size: 14px;
//           }
//         }
//       `}</style>

//       <div className="containerss">
//         {/* Image Section - LEFT */}
//         <motion.div
//           className="image-sectiony"
//           initial={{ opacity: 0, x: -50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 1, ease: "easeOut" }}
//         >
//           {/* Importing image from public folder */}
//           <img src="/image/Future-of-Data-Engineering.png" alt="Data Engineering" className="imagess" />
//         </motion.div>

//         {/* Text Section - RIGHT */}
//         <motion.div
//           className="text-sectiony"
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, ease: "easeOut" }}
//         >
//           <p className="headingyss">
//             Data <span className="bold">Engineering</span> Solutions
//           </p>

//           <p className="paragraph">
//             Data Engineering is the backbone of modern analytics and AI systems. 
//             Our solutions ensure seamless data collection, integration, and transformation, 
//             enabling businesses to make reliable, data-driven decisions.
//           </p>

//           <p className="paragraph">
//             We design and build scalable data pipelines, warehouses, and 
//             real-time streaming systems that ensure your data is always accurate, 
//             consistent, and available when you need it.
//           </p>

//           <p className="paragraph">
//             Our expertise covers the entire data lifecycle—data ingestion, 
//             processing, storage, and governance—leveraging modern tools such as 
//             Apache Spark, Kafka, Hadoop, and cloud-native platforms.
//           </p>

//           <p className="paragraph">
//             With robust data architectures, we empower organizations to unlock 
//             hidden insights, optimize performance, and drive innovation.
//           </p>
//         </motion.div>
//       </div>
//     </>
//   );
// };

// export default BusinessPromo;



import React from "react";
import { motion } from "framer-motion";

const BusinessPromo = () => {
  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
          background-color: white;
          overflow: hidden;
          flex-wrap: wrap;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 100%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 36px;
          font-weight: bold;
          color: #0e7f9d;
          text-align: left;
        }

        .bold {
          color: #ffe124;
        }

        .paragraph {
          font-size: 17px;
          color: black;
          margin: 10px 0 20px;
          text-align: left;
          font-family: 'Poppins', sans-serif;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 32px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 28px;
          }

          .paragraph {
            font-size: 14px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section - LEFT */}
        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }} // triggers when 30% visible
        >
          <img
            src="/image/Future-of-Data-Engineering.png"
            alt="Data Engineering"
            className="imagess"
          />
        </motion.div>

        {/* Text Section - RIGHT */}
        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true, amount: 0.3 }} // triggers when 30% visible
        >
          <p className="headingyss">
            Data <span className="bold">Engineering</span> Solutions
          </p>

          <p className="paragraph">
            Data Engineering is the backbone of modern analytics and AI systems.
            Our solutions ensure seamless data collection, integration, and transformation,
            enabling businesses to make reliable, data-driven decisions.
          </p>

          <p className="paragraph">
            We design and build scalable data pipelines, warehouses, and real-time
            streaming systems that ensure your data is always accurate, consistent,
            and available when you need it.
          </p>

          <p className="paragraph">
            Our expertise covers the entire data lifecycle—data ingestion, processing,
            storage, and governance—leveraging modern tools such as Apache Spark,
            Kafka, Hadoop, and cloud-native platforms.
          </p>

          <p className="paragraph">
            With robust data architectures, we empower organizations to unlock hidden
            insights, optimize performance, and drive innovation.
          </p>
        </motion.div>
      </div>
    </>
  );
};

export default BusinessPromo;
